import { useMemo } from 'react';

import { useSports } from 'contexts/SportContext';

export const useMaxCompetitorsInSport = (sportId: number) => {
  const { sports } = useSports();

  const filteredSport = useMemo(() => {
    if (sportId) {
      return sports.filter(sport => sport.id === sportId)[0];
    }
    return null;
  }, [sportId, sports]);

  return {
    maxCompetitors: filteredSport?.maxNumberOfCompetitorsInFixture,
    isTwoCompetitorsSport: filteredSport?.maxNumberOfCompetitorsInFixture === 2,
  };
};
